import { Skeleton } from 'antd';
import type { FC } from 'react';

const WIDTHS = [60, 80, 70, 90, 75, 65, 85];

export const StatusFilterSkeleton: FC = () => {
  return (
    <div style={{ display: 'flex', gap: 8, padding: '8px 16px', flexWrap: 'wrap' }}>
      {WIDTHS.map((width, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton placeholder
        <Skeleton.Button key={i} active size="small" style={{ width, height: 24 }} />
      ))}
    </div>
  );
};
